import { numberFormat } from '@mofid-securities/uikit';
import { toFormattedDate } from '@/utils/date';
import {
  TInteractiveNavChartTooltipColor,
  TInteractiveNavChartTooltipType,
} from './InteractiveNavChartTooltip.types';

export const generateTextColorClass = (
  color: TInteractiveNavChartTooltipColor | undefined
) => {
  const textColorClasses: Record<TInteractiveNavChartTooltipColor, string> = {
    success: 'text-green',
    error: 'text-error',
    warning: 'text-warning',
  };

  const textColorClass = color ? textColorClasses[color] : undefined;

  return { textColorClass };
};

export const generateValue = (
  type: TInteractiveNavChartTooltipType,
  value: number | string
) => {
  let formattedValue: string | number = value;

  switch (type) {
    case 'date':
      formattedValue = toFormattedDate(formattedValue, 'YYYY/M/D', true);
      break;
    case 'percentage':
      formattedValue = '% ' + formattedValue;
      break;
    case 'text':
      formattedValue = value;
      break;
    case 'amount':
    case 'count':
      formattedValue =
        numberFormat(formattedValue) +
        ' ' +
        (type === 'amount' ? 'ریال' : 'واحد');
      break;
    default:
      formattedValue = '-';
      break;
  }

  return { generatedValue: formattedValue };
};
